"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/Feedback/Modals/Comment.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);







// The text is kept while the modal is closed, as the class state was.
const CommentModal = ({ isOpen, onClose, onSubmit }) => {
  const [commentText, setCommentText] = _react.useState.call(void 0, '')

  const handleSubmit = () => {
    onSubmit(commentText)
    onClose()
  }

  // Stable while the props are (the Modal re-binds its Escape listener when
  // `onClose` changes).
  const handleClose = _react.useCallback.call(void 0, () => {
    onSubmit(null)
    onClose()
  }, [onSubmit, onClose])

  const handleCommentChange = (e) =>
    setCommentText(e.target.value)

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: isOpen,
      onClose: handleClose,
      title: "Tell us more about it"    ,
      className: "video-call--feedback--comment-modal-wrapper",
      size: "xs", __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}

      ,  isOpen &&
        _react2.default.createElement('textarea', {
          autoFocus: true,
          className: "video-call--feedback--comment-input",
          placeholder: "What issues did you experience?"    ,
          value: commentText,
          onChange: handleCommentChange,
          maxLength: 500, __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}
        )
      
      , _react2.default.createElement('div', { className: "video-call--feedback--comment-buttons-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}
        , _react2.default.createElement('a', {
          onClick: handleClose,
          className: "meeting--btn secondary video-call--feedback--comment-button video-call--feedback--comment--back-btn"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
, "Skip"

        )
        , _react2.default.createElement('button', {
          className: "meeting--btn video-call--feedback--comment-button" ,
          onClick: handleSubmit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}
, "Submit"

        )
      )
    )
  )
}

exports. default = CommentModal
